import React, { useCallback } from 'react';

import ym from 'react-yandex-metrika';

import { CourseContainerWidgetV2__list } from 'common.components/widgets.course-container-v2/__list/course-container-widget-v2__list';
import { useLocation } from 'react-router';
import qs from 'query-string';
import { DEFAULT_GRADE_INFORMATICS } from 'common.components/user/user.constants';

interface CourseContainerWidgetV2Props {
    className?: string;
    selectedTab?: 'elementary_school' | 'informatics';
}

/**
 * Отображает виджет курсов
 * elementary_school - актуальный контент (начальная школа)
 * informatics - список баннеров курс-контейнеров (информатика)
 * */
export const CourseContainerWidgetPublicV2 = ({ className }: CourseContainerWidgetV2Props) => {
    const { search } = useLocation();
    const query = qs.parse(search);
    const { grade } = query;
    const selectedGrade = Number(grade ?? DEFAULT_GRADE_INFORMATICS);

    const onItemClick = useCallback(() => {
        ym('reachGoal', 'teacher_select_coursecontainer', { from: 'public', grade: selectedGrade });
    }, [selectedGrade]);

    return (
        <div className={className}>
            <CourseContainerWidgetV2__list grade={selectedGrade} onItemClick={onItemClick} />
        </div>
    );
};
